export enum WREX_TYPOGRAPHY {
    /**
     * @value Align
     * @description This text is displayed on the button that open alignment selection (left, center, right) on the toolbar of a rich text editor. Clicking on it open a submenu with the tree alignment options
     */
    ALIGN = 'WREX_TYPOGRAPHY.ALIGN',
    /**
     * @value Center align
     * @description This text is displayed on the align center button on the toolbar of a rich text editor. Allowing the user to align the content to the center.
     */
    ALIGN_CENTER = 'WREX_TYPOGRAPHY.ALIGN_CENTER',
    /**
     * @value Center align (%SHORTCUT%)
     * @description This text is displayed on the align center button on the toolbar of a rich text editor. Allowing the user to align the content to the center.
     */
    ALIGN_CENTER_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.ALIGN_CENTER_WITH_SHORTCUT',
    /**
     * @value Right align
     * @description This text is displayed on the align right button on the toolbar of a rich text editor. Allowing the user to align the content to the right.
     */
    ALIGN_END = 'WREX_TYPOGRAPHY.ALIGN_END',
    /**
     * @value Right align (%SHORTCUT%)
     * @description This text is displayed on the align right button on the toolbar of a rich text editor. Allowing the user to align the content to the right.
     */
    ALIGN_END_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.ALIGN_END_WITH_SHORTCUT',
    /**
     * @value Justify
     * @description This text is displayed on the "justify" alignment button on the toolbar of a rich text editor. Allowing the user to align the content in a justified way
     */
    ALIGN_JUSTIFY = 'WREX_TYPOGRAPHY.ALIGN_JUSTIFY',
    /**
     * @value Justify (%SHORTCUT%)
     * @description This text is displayed on the "justify" alignment button on the toolbar of a rich text editor. Allowing the user to align the content in a justified way
     */
    ALIGN_JUSTIFY_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.ALIGN_JUSTIFY_WITH_SHORTCUT',
    /**
     * @value Left align
     * @description This text is displayed on the align left button on the toolbar of a rich text editor. Allowing the user to align the content to the left.
     */
    ALIGN_START = 'WREX_TYPOGRAPHY.ALIGN_START',
    /**
     * @value Left align (%SHORTCUT%)
     * @description This text is displayed on the align left button on the toolbar of a rich text editor. Allowing the user to align the content to the left.
     */
    ALIGN_START_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.ALIGN_START_WITH_SHORTCUT',
    /**
     * @value Bold
     * @description text editor format bold button tooltip
     */
    BOLD_BUTTON = 'FRONT.TEXT_EDITOR.FORMAT.BOLD_BUTTON',
    /**
     * @value Bold (%SHORTCUT%)
     * @description text editor format bold button tooltip
     */
    BOLD_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.BOLD_WITH_SHORTCUT',
    /**
     * @value Divider
     * @description Label displayed for an option button displaying a separator in the toolbar of a rich text editor. Clicking on it adds the separator in the editor.
     */
    DIVIDER = 'WREX_TYPOGRAPHY.DIVIDER',
    /**
     * @value Formatting options
     * @description The tooltip for the text editor menu for formatting options (Heading, paragraph, bold, italic, etc.)
     */
    FORMATTING_OPTIONS_TOOLTIP = 'FRONT.TEXT_EDITOR.FORMAT.FORMATTING_OPTIONS_TOOLTIP',
    /**
     * @value Heading 1
     * @description The label for the "Heading 1" option in the select allowing the user to format his selection in the text editor
     */
    HEADING1_LABEL = 'FRONT.TEXT_EDITOR.HEADINGS.HEADING1',
    /**
     * @value Heading 2
     * @description The label for the "Heading 2" option in the select allowing the user to format his selection in the text editor
     */
    HEADING2_LABEL = 'FRONT.TEXT_EDITOR.HEADINGS.HEADING2',
    /**
     * @value Heading 3
     * @description The label for the "Heading 3" option in the select allowing the user to format his selection in the text editor
     */
    HEADING3_LABEL = 'WREX_TYPOGRAPHY.HEADING3',
    /**
     * @value Paragraph style
     * @description text editor block style selector tooltip
     */
    HEADINGS_TYPE_SELECTION = 'FRONT.TEXT_EDITOR.HEADINGS.TYPE_SELECTION',
    /**
     * @value Code
     */
    INLINE_CODE_BUTTON = 'FRONT.TEXT_EDITOR.FORMAT.CODE_BUTTON',
    /**
     * @value Italic
     * @description text editor format italic button tooltip
     */
    ITALIC_BUTTON = 'FRONT.TEXT_EDITOR.FORMAT.ITALIC_BUTTON',
    /**
     * @value Italic (%SHORTCUT%)
     * @description text editor format italic button tooltip
     */
    ITALIC_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.ITALIC_WITH_SHORTCUT',
    /**
     * @value More insert options
     */
    MORE_INSERT_OPTIONS = 'FRONT.TEXT_EDITOR.MORE_INSERT_OPTIONS',
    /**
     * @value Normal text
     * @description The label for the "Normal text" option in the select allowing the user to format his selection in the text editor
     */
    NORMAL_TEXT_LABEL = 'FRONT.TEXT_EDITOR.HEADINGS.NORMAL_TEXT',
    /**
     * @value Redo
     */
    REDO_BUTTON = 'FRONT.TEXT_EDITOR.HISTORY.REDO',
    /**
     * @value Redo (%SHORTCUT%)
     */
    REDO_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.REDO_WITH_SHORTCUT',
    /**
     * @value Strike
     */
    STRIKETHROUGH = 'WREX_TYPOGRAPHY.STRIKETHROUGH',
    /**
     * @value Strike (%SHORTCUT%)
     */
    STRIKETHROUGH_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.STRIKETHROUGH_WITH_SHORTCUT',
    /**
     * @value Title 1
     */
    TITLE1_LABEL = 'WREX_TYPOGRAPHY.TITLE1_LABEL',
    /**
     * @value Title 2
     */
    TITLE2_LABEL = 'WREX_TYPOGRAPHY.TITLE2_LABEL',
    /**
     * @value Title 3
     */
    TITLE3_LABEL = 'WREX_TYPOGRAPHY.TITLE3_LABEL',
    /**
     * @value Title 4
     */
    TITLE4_LABEL = 'WREX_TYPOGRAPHY.TITLE4_LABEL',
    /**
     * @value Title 5
     */
    TITLE5_LABEL = 'WREX_TYPOGRAPHY.TITLE5_LABEL',
    /**
     * @value Title 6
     */
    TITLE6_LABEL = 'WREX_TYPOGRAPHY.TITLE6_LABEL',
    /**
     * @value Underline
     * @description This text is displayed on the Underline button on the toolbar of a rich text editor. Allowing the user to apply an underline effect on his text.
     */
    UNDERLINE = 'WREX_TYPOGRAPHY.UNDERLINE',
    /**
     * @value Underline (%SHORTCUT%)
     * @description The tooltip displayed when hovering the Underline button on the toolbar of a rich text editor. Allowing the user to apply an underline effect on his text.
     */
    UNDERLINE_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.UNDERLINE_WITH_SHORTCUT',
    /**
     * @value Undo
     */
    UNDO_BUTTON = 'FRONT.TEXT_EDITOR.HISTORY.UNDO',
    /**
     * @value Undo (%SHORTCUT%)
     */
    UNDO_WITH_SHORTCUT = 'WREX_TYPOGRAPHY.UNDO_WITH_SHORTCUT',
}
